<template>
  <Layout>
    <TransitionPage>
      <router-view />
    </TransitionPage>
  </Layout>
</template>
<script>
import TransitionPage from '@/components/TransitionPage.vue';
import Layout from '@/views/Layout.vue';

export default {
  components: {
    TransitionPage,
    Layout
  }
}
</script>
<style lang="scss">
:root {
  --theme: #FFE9A3;
  --secondary-theme: #008CFF;

  --resume-shade: #384347;

  --light: #FBFBFB;
  --grey: #E1E0DF;

  --dark-shade: #332F21;
  --light-shade: #FFFDF6;
  --medium-shade: #E6D293;
  --max-app-width: 1440px;
  --max-content-width: 650px;
  --max-app-scale: 1200px;
}

html {
  font-size: 1vw;
  @media screen and (min-width: 1200px) {
    font-size: 80%;
  }
}

* {
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

html,
body {
  width: 100%;
  height: 100%;
  margin: 0px;
  background: var(--theme);
}

.linky {
  font-weight: 600;
  color: var(--dark-shade);
  text-decoration: underline;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

/* total width */
body::-webkit-scrollbar {
    background-color:#fff;
    width:16px
}

/* background of the scrollbar except button or resizer */
body::-webkit-scrollbar-track {
    background-color:#fff
}

/* scrollbar itself */
body::-webkit-scrollbar-thumb {
    background-color:#babac0;
    border-radius:16px;
    border:4px solid #fff
}

/* set button(top and bottom of the scrollbar) */
body::-webkit-scrollbar-button {display:none}
</style>